import { Component } from '@angular/core';
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'wci-cta',
    imports: [ButtonComponent],
    templateUrl: './cta.component.html',
    styles: ``,
})
export class CtaComponent {}
